import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "@cc/react-components";

const MedicationPosologySimple = () => {
  const [t] = useTranslation();

  return (
    <Page>
      <Page.Body>
        <Page.Title>{t("medicationFlow.posologySimple")}</Page.Title>
      </Page.Body>
    </Page>
  );
};

export default MedicationPosologySimple;
